<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row>
                <b-col cols="12">
                    <ValidationProvider name="bank_id" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('bank')">
                            <bank-selectbox :validate-error="errors[0]" v-model="formData.bank_id">
                            </bank-selectbox>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="6">
                    <ValidationProvider name="start_date" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('start_date')">
                            <select-date
                                v-model="formData.start_date" :validation-error="errors[0]"> </select-date>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols=6>
                    <ValidationProvider name="end_date" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('end_date')">
                            <select-date
                                v-model="formData.end_date" :validation-error="errors[0]"></select-date>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols=12>
                <ValidationProvider name="card_type" rules="required" v-slot="{ valid, errors }">
                    <b-form-group :label="$t('card_type')">
                        <multi-selectbox :multiple="false" v-model="formData.card_type"
                                         :validateError="errors[0]"
                                         :options="[{ value: 'credit_card', text: $t('credit_card') }, { value: 'debit_card', text: $t('bank_card') }]"></multi-selectbox>

                    </b-form-group>
                </ValidationProvider>
                </b-col>
                <b-col cols="12">
                    <ValidationProvider name="currency" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('currency')">
                            <parameter-selectbox :validate-error="errors[0]"  code="currencies" v-model="formData.currency"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12">
                    <ValidationProvider name="commission_rate" rules="required|dynamic_between:0,100" v-slot="{valid, errors}">
                        <b-form-group :label="$t('commission_rate')">
                            <b-input
                                v-model="formData.commission_rate"
                                type="number"
                                max="100"
                                min="0"
                                class="text-center"
                            ></b-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="6">
                    <ValidationProvider name="date_between" rules="required|dynamic_between:0,12" v-slot="{valid, errors}">
                        <b-form-group :label="$t('installment')">
                            <b-input
                                v-model="formData.installment"
                                type="number"
                                max="12"
                                min="0"
                                class="text-center"
                            ></b-input>
                        </b-form-group>
                        <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                    </ValidationProvider>
                </b-col>
                <b-col cols="6">
                    <ValidationProvider name="days" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('number_of_days')">
                          <b-input
                              v-model="formData.days"
                              type="number"
                              min="1"
                              class="text-center"
                          ></b-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />

                        </b-form-group>
                    </ValidationProvider>
                </b-col>
            </b-row>
            <div class="d-flex justify-content-center mt-2">
                <ProcessingButton   @click="createForm" :processing="formLoading" :disabled="formLoading" />
            </div>
        </ValidationObserver>
    </div>
</template>

<script>
import {ValidationProvider, ValidationObserver} from "vee-validate"
import BankSelectbox from "@/components/interactive-fields/BankSelectbox.vue";
import ProcessingButton from "@/components/elements/ProcessingButton.vue";
import DaysSelectbox from "@/components/interactive-fields/DaysSelectbox.vue";
import PosReturnDaysServices from "@/services/PosReturnDaysServices";

export default {
    components: {
        DaysSelectbox,
        ProcessingButton,
        BankSelectbox,
        ValidationProvider,
        ValidationObserver,
    },
    props: {
        formId:{
            type: Number,
        }

    },
    data() {
        return {
            formData: {
                bank_id:null,
                start_date:null,
                end_date:null,
                installment:null,
                days:null
            },
            formLoading: false,
        }
    },
    created() {
        this.getForm()
    },
    methods: {
        async getForm(){
          try {
              const res =await PosReturnDaysServices.show(this.formId);
              this.formData=res.data.data;
          } catch (e){
              this.showErrors(e)
          }
        },
        async createForm() {
            if(this.checkPermission('posreturnday_update')){
                const isValid = await this.$refs.formModalValidate.validate();
                if (isValid) {
                    this.formLoading = true;
                    PosReturnDaysServices.update(this.formId,this.formData)
                        .then(response => {
                            this.$toast.success(this.$t('api.' + response.data.message));
                            this.$emit('updateFormSuccess', true);
                        })
                        .catch(e => {
                            this.showErrors(e, this.$refs.formModalValidate);
                        })
                        .finally(() => {
                            this.formLoading = false
                        })
                }
            } else {
                this.$toast.error(this.$t('you_are_not_authorized_for_this_operation'))
            }
        }
    }
}
</script>

